/* =====================================================
   COLLECTION FILTERS — client-side filtering engine
   Data source: product metafield custom.filter_data (JSON):
   {
     "d_brand": ["LV", "Louis Vuitton"],
     "scentFamily": "Fresh",
     "tier": "Significant",
     "retailPrice": { "50ml": 350, "100ml": null },
     "occasionCollections": ["Everyday", "Office", "Warm Weather"],
     "gender": "unisex"            // optional
   }
   Fallbacks: tags gender:/scent:/brand:/intensity:, variants (sizes),
   Shopify collections (occasions).
   Smart visibility: a filter group/dropdown is hidden when it
   has fewer than 2 options across the products on the page.

   Panel behaviour:
   - Desktop: sidebar, closed by default, toggled by the button.
   - Mobile: bottom sheet sliding up from the bottom with overlay,
     body scroll-lock, swipe-down-to-close and "Show N products" CTA.
   ===================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-cf-root]');
  if (!root) return;

  var grid = root.querySelector('[data-product-grid]');
  var gridWrap = root.querySelector('[data-products-container]');
  var paginationEl = root.querySelector('[data-pagination]');
  var countEl = root.querySelector('[data-cf-count]');
  var emptyEl = root.querySelector('[data-cf-empty]');
  var panel = root.querySelector('[data-cf-panel]');
  var overlay = root.querySelector('[data-cf-overlay]');
  var chipsEl = root.querySelector('[data-cf-chips]');
  var clearAllBtn = root.querySelector('[data-cf-clear-all]');
  var clearAllMobileBtn = root.querySelector('[data-cf-clear-all-mobile]');
  var toggleBtn = root.querySelector('[data-cf-panel-toggle]');
  var applyBtn = root.querySelector('[data-cf-panel-apply]');
  var applyCountEl = root.querySelector('[data-cf-apply-count]');
  var searchInput = root.querySelector('[data-cf-search]');
  var sortSelect = root.querySelector('[data-cf-sort]');
  var sortSelects = root.querySelectorAll('[data-cf-sort]');

  var mqMobile = window.matchMedia('(max-width: 989px)');

  var FILTER_KEYS = ['gender', 'scent', 'brand', 'collection', 'intensity', 'size'];

  var LABELS = {
    gender: { women: 'Women', men: 'Men', unisex: 'Unisex' },
    intensity: { subtle: 'Subtle', significant: 'Significant', statement: 'Statement' }
  };
  var INTENSITY_ORDER = ['subtle', 'significant', 'statement'];
  var GENDER_ORDER = ['women', 'men', 'unisex'];

  /* Inline icons for Scent Family options */
  var SCENT_ICONS = {
    warm: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22c4 0 7-2.7 7-6.5 0-2.8-1.7-4.6-3-6.5-1.2-1.7-2-3.3-2-6-2.5 1.5-4 4.2-4 6.5 0 1.2.3 2 .3 2S9 10.5 8 9c-1.8 1.6-3 3.9-3 6.5C5 19.3 8 22 12 22z"/></svg>',
    flowery: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2.5"/><path d="M12 9.5c-2.6 0-3.4-2.3-2.4-3.8C10.3 4.6 12 4.5 12 3c0 1.5 1.7 1.6 2.4 2.7 1 1.5.2 3.8-2.4 3.8z"/><path d="M14.5 12c0-2.6 2.3-3.4 3.8-2.4 1.1.7 1.2 2.4 2.7 2.4-1.5 0-1.6 1.7-2.7 2.4-1.5 1-3.8.2-3.8-2.4z"/><path d="M12 14.5c2.6 0 3.4 2.3 2.4 3.8-.7 1.1-2.4 1.2-2.4 2.7 0-1.5-1.7-1.6-2.4-2.7-1-1.5-.2-3.8 2.4-3.8z"/><path d="M9.5 12c0 2.6-2.3 3.4-3.8 2.4C4.6 13.7 4.5 12 3 12c1.5 0 1.6-1.7 2.7-2.4 1.5-1 3.8-.2 3.8 2.4z"/></svg>',
    gourmand: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 11a5 5 0 0 1 10 0"/><path d="M5 11h14l-1.5 9a1.5 1.5 0 0 1-1.5 1.3H8a1.5 1.5 0 0 1-1.5-1.3L5 11z"/><path d="M12 6V3.5M12 3.5c0-1 .8-1.5 1.7-1.2"/></svg>',
    fresh: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21a6.5 6.5 0 0 0 6.5-6.5C18.5 10 12 3 12 3S5.5 10 5.5 14.5A6.5 6.5 0 0 0 12 21z"/><path d="M9 14.5a3 3 0 0 0 3 3"/></svg>',
    herbal: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20C4 11 9 5 20 4c-1 11-7 16-16 16z"/><path d="M4 20c3-6 7-10 12-12"/></svg>',
    earthy: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19h18"/><path d="M5 19l5-9 3 5 2-3 4 7"/></svg>',
    woody: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l5 7h-3l4 6h-4v5h-4v-5H6l4-6H7l5-7z"/></svg>',
    citrus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 3.5v17M3.5 12h17M6 6l12 12M18 6L6 18"/></svg>',
    spicy: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 5c0 7-3 14-8 16 7 0 13-6 13-13 0-1.7-.6-3-1.7-3.8C18 3.4 16 3.6 16 5z"/><path d="M16 5c0-1.5-1-2.5-2.5-2.5"/></svg>',
    aquatic: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9c2 0 2.5 1.5 4.5 1.5S10 9 12 9s2.5 1.5 4.5 1.5S19 9 21 9"/><path d="M3 15c2 0 2.5 1.5 4.5 1.5S10 15 12 15s2.5 1.5 4.5 1.5S19 15 21 15"/></svg>',
    musky: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a7 7 0 0 1 7 7c0 5-3 8-7 11-4-3-7-6-7-11a7 7 0 0 1 7-7z"/><circle cx="12" cy="10" r="2.5"/></svg>'
  };
  /* aliases */
  SCENT_ICONS.floral = SCENT_ICONS.flowery;
  SCENT_ICONS.sweet = SCENT_ICONS.gourmand;
  SCENT_ICONS.green = SCENT_ICONS.herbal;
  SCENT_ICONS.wood = SCENT_ICONS.woody;
  SCENT_ICONS.fruity = SCENT_ICONS.citrus;

  function scentIcon(key) {
    var svg = SCENT_ICONS[key];
    return svg ? '<span class="cf-check__icon">' + svg + '</span>' : '';
  }

  var state = {
    search: '',
    sort: 'relevance',
    priceMin: null,
    priceMax: null,
    filters: { gender: [], scent: [], brand: [], collection: [], intensity: [], size: [] }
  };

  var priceBounds = { min: 0, max: 0 };
  var items = [];
  var optionCounts = {};

  function lower(v) { return String(v).toLowerCase(); }
  function toArr(v) {
    if (v == null || v === '') return [];
    return Array.isArray(v) ? v : [v];
  }
  function slug(v) {
    return lower(v).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  /* ---------- Parse item dataset ---------- */
  function parseItem(el, index) {
    var d = el.dataset;
    var splitVals = function (s) {
      return (s || '').split(',').map(function (v) { return v.trim().toLowerCase(); }).filter(Boolean);
    };

    /* Fallbacks from tags / variants / shopify collections */
    var gender = splitVals(d.cfGender);
    var scent = splitVals(d.cfScent);
    var brand = (d.cfBrand || '').split(',').map(function (v) { return v.trim(); }).filter(Boolean);
    var intensity = splitVals(d.cfIntensity);
    var sizes = splitVals(d.cfSizes);
    var brandAliases = [];

    var collections = {};
    (d.cfCollections || '').split('|').forEach(function (pair) {
      if (!pair) return;
      var p = pair.split('~');
      if (p[0] && p[0] !== 'all') collections[slug(p[0])] = (p[1] || p[0]).trim();
    });

    /* JSON metafield overrides everything */
    var json = null;
    if (d.cfJson) {
      try {
        json = JSON.parse(d.cfJson);
        if (typeof json === 'string') json = JSON.parse(json); /* double-encoded */
      } catch (e) { json = null; }
    }

    if (json && typeof json === 'object') {
      /* gender from Liquid (snippets/product-gender) wins so SSR and JS agree */
      if (json.gender && !gender.length) gender = splitVals(toArr(json.gender).join(','));
      if (json.scentFamily) scent = toArr(json.scentFamily).map(lower);
      if (json.tier) intensity = toArr(json.tier).map(lower);

      var brandSrc = (json.d_brand != null) ? json.d_brand : json.brand;
      if (brandSrc) {
        var arr = toArr(brandSrc).map(String);
        brandAliases = arr.slice();
        /* canonical display name = longest entry (full brand name) */
        var canonical = arr.reduce(function (a, b) { return b.length > a.length ? b : a; }, arr[0] || '');
        brand = canonical ? [canonical] : [];
      }

      if (json.occasionCollections) {
        collections = {};
        toArr(json.occasionCollections).forEach(function (name) {
          collections[slug(name)] = String(name);
        });
      }

      if (json.retailPrice && !sizes.length) {
        sizes = Object.keys(json.retailPrice)
          .filter(function (k) { return json.retailPrice[k] != null; })
          .map(lower);
      }
    }

    var collectionNames = Object.keys(collections).map(function (h) { return collections[h]; });

    return {
      el: el,
      index: index,
      title: (d.cfTitle || '').toLowerCase(),
      searchText: (
        (d.cfTitle || '') + ' ' + (d.cfType || '') + ' ' + (d.cfTags || '') + ' ' +
        brand.join(' ') + ' ' + brandAliases.join(' ') + ' ' +
        scent.join(' ') + ' ' + collectionNames.join(' ')
      ).toLowerCase(),
      gender: gender,
      scent: scent,
      brand: brand,
      intensity: intensity,
      size: sizes,
      price: parseFloat(d.cfPrice || '0') / 100,
      collections: collections,
      /* slug keys used for matching and in the URL */
      keys: {
        gender: gender.map(slug),
        scent: scent.map(slug),
        brand: brand.map(slug),
        intensity: intensity.map(slug),
        size: sizes.map(slug)
      }
    };
  }

  function collectItems() {
    items = [];
    var nodes = grid.querySelectorAll('[data-cf-item]');
    for (var i = 0; i < nodes.length; i++) items.push(parseItem(nodes[i], i));
  }

  /* ---------- Load all pages (so filtering covers everything) ---------- */
  function loadAllPages() {
    var totalPages = parseInt(root.dataset.totalPages || '1', 10);
    if (totalPages <= 1) { onAllLoaded(); return; }

    var sectionId = root.dataset.sectionId;
    var collectionUrl = root.dataset.collectionUrl || window.location.pathname;
    var sortParam = new URLSearchParams(window.location.search).get('sort_by');
    var pending = [];

    for (var p = 2; p <= totalPages; p++) {
      var url = collectionUrl + '?page=' + p + '&sections=' + sectionId + (sortParam ? '&sort_by=' + sortParam : '');
      pending.push(
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
            return doc.querySelectorAll('[data-product-grid] [data-cf-item]');
          })
          .catch(function () { return []; })
      );
    }

    Promise.all(pending).then(function (pages) {
      pages.forEach(function (nodes) {
        for (var i = 0; i < nodes.length; i++) grid.appendChild(nodes[i]);
      });
      if (paginationEl) paginationEl.remove();
      onAllLoaded();
    });
  }

  function onAllLoaded() {
    collectItems();
    computePriceBounds();
    buildOptionLists();
    initPriceSlider();
    readStateFromUrl(); /* restore filters from the URL: path gender, params, legacy f_* */
    apply('replace'); /* initial render — no animation; legacy f_* links are rewritten */
  }

  /* ---------- URL <-> state sync ----------
     Filters are reflected in the address bar so a filtered view can be
     copied, shared and reopened:
       /collections/women?scent=warm,fresh&occasion=date-night
       /collections/all?gender=women,unisex
     Param names avoid Shopify-reserved ones: the occasion filter is
     "occasion" (not "collection"), text search is "search" (not "q").
     Legacy links with the old "f_" prefix (f_gender, f_scent, ...) are
     still read and rewritten to the new format with replaceState.
     Gender entry pages (/collections/women|men|unisex, see the section's
     gender map) pre-select their gender; unticking it moves the URL to
     /collections/all without a reload. */
  var URL_KEYS = {
    gender: 'gender', scent: 'scent', brand: 'brand', collection: 'occasion',
    intensity: 'intensity', size: 'size',
    search: 'search', sort: 'sort', priceMin: 'price_min', priceMax: 'price_max'
  };
  var LEGACY_KEYS = {
    gender: 'f_gender', scent: 'f_scent', brand: 'f_brand', collection: 'f_collection',
    intensity: 'f_intensity', size: 'f_size',
    search: 'f_q', sort: 'f_sort', priceMin: 'f_price_min', priceMax: 'f_price_max'
  };

  var allUrl = root.dataset.allUrl || '/collections/all';
  var hiddenCollections = root.dataset.hiddenCollections || '';

  /* "women:women,men:men" -> { women: 'women', men: 'men' } */
  var genderByHandle = {};
  (root.dataset.genderMap || '').split(',').forEach(function (pair) {
    var p = pair.split(':');
    if (p[0] && p[1]) genderByHandle[p[0].trim()] = p[1].trim();
  });

  function pathGenderFor(pathname) {
    var m = /\/collections\/([^\/?#]+)(?:\/[^\/?#]+)?\/?$/.exec(pathname);
    return m && genderByHandle[m[1]] ? genderByHandle[m[1]] : '';
  }

  /* Raw value for a state key: new name first, then legacy f_* name.
     Sets found.legacy when a legacy key is present in the URL. */
  function readParam(params, key, found) {
    if (params.has(LEGACY_KEYS[key])) found.legacy = true;
    if (params.has(URL_KEYS[key])) return params.get(URL_KEYS[key]);
    if (params.has(LEGACY_KEYS[key])) return params.get(LEGACY_KEYS[key]);
    return null;
  }

  function splitList(raw) {
    return raw.split(',').map(function (v) { return slug(v.trim()); }).filter(Boolean);
  }

  /* Read state from location. Returns true when legacy f_* params were found. */
  function readStateFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var found = { legacy: false };

    FILTER_KEYS.forEach(function (key) {
      var raw = readParam(params, key, found);
      state.filters[key] = raw ? splitList(raw) : [];
    });
    /* No explicit gender in the URL -> take it from the path */
    if (readParam(params, 'gender', {}) === null) {
      var pg = pathGenderFor(window.location.pathname);
      state.filters.gender = pg ? [pg] : [];
    }

    var q = readParam(params, 'search', found);
    state.search = q ? q.toLowerCase() : '';
    if (searchInput) searchInput.value = q || '';

    var sort = readParam(params, 'sort', found);
    state.sort = sort || 'relevance';
    for (var ssi = 0; ssi < sortSelects.length; ssi++) sortSelects[ssi].value = state.sort;

    var pmin = readParam(params, 'priceMin', found);
    var pmax = readParam(params, 'priceMax', found);
    state.priceMin = (pmin != null && !isNaN(parseFloat(pmin))) ? parseFloat(pmin) : priceBounds.min;
    state.priceMax = (pmax != null && !isNaN(parseFloat(pmax))) ? parseFloat(pmax) : priceBounds.max;

    /* Reflect restored state in checkboxes */
    root.querySelectorAll('input[data-cf-filter]').forEach(function (input) {
      var key = input.dataset.cfFilter;
      input.checked = !!(state.filters[key] && state.filters[key].indexOf(input.value) > -1);
    });

    /* Reflect restored state in the price slider */
    if (priceMinInput && priceMaxInput) {
      priceMinInput.value = state.priceMin;
      priceMaxInput.value = state.priceMax;
      updatePriceUI(state.priceMin, state.priceMax);
    }
    return found.legacy;
  }

  /* Our filter params as [name, value] pairs, in a stable order.
     Multiple values are comma-joined (kept as a literal comma in the URL). */
  function filterPairs(includeGender) {
    var pairs = [];
    FILTER_KEYS.forEach(function (key) {
      if (key === 'gender' && !includeGender) return;
      if (state.filters[key].length) pairs.push([URL_KEYS[key], state.filters[key].join(',')]);
    });
    if (state.search) pairs.push([URL_KEYS.search, state.search]);
    if (state.sort && state.sort !== 'relevance') pairs.push([URL_KEYS.sort, state.sort]);
    if (state.priceMin != null && state.priceMin > priceBounds.min) pairs.push([URL_KEYS.priceMin, String(state.priceMin)]);
    if (state.priceMax != null && state.priceMax < priceBounds.max) pairs.push([URL_KEYS.priceMax, String(state.priceMax)]);
    return pairs;
  }

  function encodePairs(pairs) {
    return pairs.map(function (p) {
      return encodeURIComponent(p[0]) + '=' + p[1].split(',').map(encodeURIComponent).join(',');
    }).join('&');
  }

  function isOurParam(name) {
    return Object.keys(URL_KEYS).some(function (k) {
      return name === URL_KEYS[k] || name === LEGACY_KEYS[k];
    });
  }

  /* mode: 'push' (user action), 'replace' (initial normalisation), 'none' (popstate) */
  function writeStateToUrl(mode) {
    if (mode === 'none') return;
    var path = window.location.pathname;
    var pathGender = pathGenderFor(path);
    var g = state.filters.gender;
    var pathMatches = !!pathGender && g.length === 1 && g[0] === pathGender;

    /* Unticking / changing the entry-page gender leaves the gender page */
    if (pathGender && !pathMatches && mode === 'push') {
      path = allUrl;
      pathGender = '';
    }

    var pairs = filterPairs(!pathMatches);
    /* explicit empty ?gender= on an entry page means "no gender" */
    if (pathGender && !pathMatches && !g.length) pairs.unshift([URL_KEYS.gender, '']);

    /* keep everything that is not ours (utm_*, gclid, sort_by, ...) as-is */
    var rest = window.location.search.replace(/^\?/, '').split('&').filter(function (part) {
      if (!part) return false;
      var name;
      try { name = decodeURIComponent(part.split('=')[0].replace(/\+/g, ' ')); } catch (e) { name = part.split('=')[0]; }
      if (isOurParam(name)) return false;
      if (path !== window.location.pathname && name === 'page') return false;
      return true;
    });

    var qs = encodePairs(pairs);
    if (rest.length) qs = qs ? qs + '&' + rest.join('&') : rest.join('&');

    var newUrl = path + (qs ? '?' + qs : '') + window.location.hash;
    var curUrl = window.location.pathname + window.location.search + window.location.hash;
    if (newUrl === curUrl) return;
    if (mode === 'push') window.history.pushState({ cf: true }, '', newUrl);
    else window.history.replaceState(window.history.state, '', newUrl);
  }

  /* ---------- Heading swap (gender entry page <-> whole catalog) ---------- */
  var titleEl = root.querySelector('[data-cf-heading]');
  var descEl = root.querySelector('[data-cf-desc]');
  var allDescTpl = root.querySelector('template[data-cf-all-desc]');
  var entryTitle = titleEl ? titleEl.innerHTML : '';
  var entryDesc = descEl ? descEl.innerHTML : '';

  function updateHeading() {
    if (!root.dataset.pathGender || !titleEl) return;
    var pg = pathGenderFor(window.location.pathname);
    var g = state.filters.gender;
    var onEntry = !!pg && g.length === 1 && g[0] === pg;
    if (onEntry) titleEl.innerHTML = entryTitle;
    else titleEl.textContent = titleEl.dataset.allTitle || '';
    if (!descEl) return;
    if (onEntry) {
      descEl.innerHTML = entryDesc;
      descEl.hidden = false;
    } else if (allDescTpl) {
      descEl.innerHTML = allDescTpl.innerHTML;
      descEl.hidden = false;
    } else {
      descEl.hidden = true;
    }
    descEl.classList.toggle('cf-head__desc--clamp', onEntry);
  }

  /* ---------- Collection tabs keep the current filters ----------
     e.g. on /collections/women?scent=warm the "Best sellers" tab links to
     /collections/best-sellers?gender=women&scent=warm */
  function updateTabs() {
    var qs = encodePairs(filterPairs(true));
    root.querySelectorAll('a[data-cf-tab]').forEach(function (a) {
      if (a.dataset.cfBase == null) a.dataset.cfBase = a.getAttribute('href') || '';
      var base = a.dataset.cfBase;
      a.setAttribute('href', qs ? base + (base.indexOf('?') > -1 ? '&' : '?') + qs : base);
    });
  }

  /* Back / forward: restore the filter state from the URL */
  window.addEventListener('popstate', function () {
    if (!items.length) return;
    clearTimeout(smoothTimer);
    clearTimeout(smoothInTimer);
    if (gridWrap) {
      gridWrap.classList.remove('cf-grid--out', 'cf-grid--in');
      gridWrap.style.minHeight = '';
    }
    readStateFromUrl();
    apply('none');
  });

  /* ---------- Build filter option lists dynamically ---------- */
  function uniqueValues(key) {
    var map = {}; /* lowercased -> display */
    items.forEach(function (it) {
      it[key].forEach(function (v) {
        var k = lower(v);
        if (!map[k]) {
          map[k] = (LABELS[key] && LABELS[key][k]) ? LABELS[key][k] : String(v);
        }
      });
    });
    return map;
  }

  function buildCheckbox(key, value, label, extraHtml, iconHtml) {
    return '<label class="cf-check"><input type="checkbox" data-cf-filter="' + key + '" value="' +
      String(value).replace(/"/g, '&quot;') + '">' + (iconHtml || '') + '<span>' + label + '</span>' + (extraHtml || '') + '</label>';
  }

  function buildOptionLists() {
    optionCounts = {};

    /* Gender — only values that actually exist on products */
    var genders = uniqueValues('gender');
    var html = '';
    var gKeys = GENDER_ORDER.filter(function (g) { return genders[g]; });
    Object.keys(genders).forEach(function (g) { if (gKeys.indexOf(g) === -1) gKeys.push(g); });
    gKeys.forEach(function (g) {
      html += buildCheckbox('gender', slug(g), LABELS.gender[g] || genders[g]);
    });
    optionCounts.gender = gKeys.length;
    fill('gender', html);

    /* Scent family */
    var scents = uniqueValues('scent');
    var sKeys = Object.keys(scents).sort();
    html = '';
    sKeys.forEach(function (k) {
      var label = scents[k].charAt(0).toUpperCase() + scents[k].slice(1);
      html += buildCheckbox('scent', slug(k), label, '', scentIcon(slug(k)));
    });
    optionCounts.scent = sKeys.length;
    fill('scent', html);

    /* Inspired-by brands (full names from JSON metafield) */
    var brandMap = {};
    items.forEach(function (it) {
      it.brand.forEach(function (b) { brandMap[lower(b)] = b; });
    });
    var bKeys = Object.keys(brandMap).sort(function (a, b) { return brandMap[a].localeCompare(brandMap[b]); });
    html = '';
    bKeys.forEach(function (k) {
      html += buildCheckbox('brand', slug(k), brandMap[k]);
    });
    optionCounts.brand = bKeys.length;
    fill('brand', html);

    /* Collections / occasions */
    var colMap = {};
    items.forEach(function (it) {
      Object.keys(it.collections).forEach(function (h) {
        colMap[h] = it.collections[h];
      });
    });
    var cKeys = Object.keys(colMap).sort(function (a, b) { return colMap[a].localeCompare(colMap[b]); });
    html = '';
    /* collections from Theme settings -> Hidden collections never appear here */
    cKeys = cKeys.filter(function (h) { return hiddenCollections.indexOf(',' + h + ',') === -1; });
    cKeys.forEach(function (h) {
      html += buildCheckbox('collection', h, colMap[h]);
    });
    optionCounts.collection = cKeys.length;
    fill('collection', html);

    /* Intensity — fixed order, only present levels, with bars */
    var present = uniqueValues('intensity');
    var iKeys = INTENSITY_ORDER.filter(function (lvl) { return present[lvl]; });
    html = '';
    iKeys.forEach(function (lvl) {
      var pos = INTENSITY_ORDER.indexOf(lvl);
      var bars = '<span class="cf-bars">';
      for (var b = 0; b < 3; b++) bars += '<i class="' + (b <= pos ? 'on' : '') + '"></i>';
      bars += '</span>';
      html += buildCheckbox('intensity', lvl, LABELS.intensity[lvl], bars);
    });
    optionCounts.intensity = iKeys.length;
    fill('intensity', html);

    /* Sizes */
    var sizes = uniqueValues('size');
    var zKeys = Object.keys(sizes).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    html = '';
    zKeys.forEach(function (k) {
      html += buildCheckbox('size', slug(k), sizes[k]);
    });
    optionCounts.size = zKeys.length;
    fill('size', html);

    updateGroupVisibility();

    /* Bind change events */
    root.querySelectorAll('input[data-cf-filter]').forEach(function (input) {
      input.addEventListener('change', function () {
        setFilter(this.dataset.cfFilter, this.value, this.checked);
      });
    });
  }

  function fill(key, html) {
    root.querySelectorAll('[data-cf-options="' + key + '"]').forEach(function (box) {
      box.innerHTML = html;
    });
  }

  /* Hide dropdowns & panel groups with fewer than 2 options */
  function updateGroupVisibility(){
    FILTER_KEYS.forEach(function (key) {
      var n = optionCounts[key] || 0;
      root.querySelectorAll('[data-cf-options="' + key + '"]').forEach(function (box) {
        var wrap = box.closest('.cf-dd') || box.closest('.cf-group');
        if (wrap) wrap.style.display = n < 2 ? 'none' : '';
      });
    });
  }

  /* ---------- State management ---------- */
  function setFilter(key, value, on) {
    var arr = state.filters[key];
    var idx = arr.indexOf(value);
    if (on && idx === -1) arr.push(value);
    if (!on && idx > -1) arr.splice(idx, 1);
    syncInputs(key, value, on);
    applySmooth();
  }

  function syncInputs(key, value, on) {
    root.querySelectorAll('input[data-cf-filter="' + key + '"]').forEach(function (input) {
      if (input.value === value) input.checked = on;
    });
  }

  function clearAll() {
    FILTER_KEYS.forEach(function (k) { state.filters[k] = []; });
    state.priceMin = priceBounds.min;
    state.priceMax = priceBounds.max;
    state.search = '';
    if (searchInput) searchInput.value = '';
    root.querySelectorAll('input[data-cf-filter]').forEach(function (i) { i.checked = false; });
    resetPriceSlider();
    applySmooth();
  }

  /* ---------- Filtering ---------- */
  function matches(it) {
    if (state.search) {
      if (it.searchText.indexOf(state.search) === -1) return false;
    }
    var f = state.filters;
    if (f.gender.length && !intersects(it.keys.gender, f.gender)) return false;
    if (f.scent.length && !intersects(it.keys.scent, f.scent)) return false;
    if (f.intensity.length && !intersects(it.keys.intensity, f.intensity)) return false;
    if (f.size.length && !intersects(it.keys.size, f.size)) return false;
    if (f.brand.length && !intersects(it.keys.brand, f.brand)) return false;
    if (f.collection.length) {
      var has = f.collection.some(function (h) { return !!it.collections[h]; });
      if (!has) return false;
    }
    if (state.priceMin != null && it.price < state.priceMin) return false;
    if (state.priceMax != null && it.price > state.priceMax) return false;
    return true;
  }

  function intersects(a, b) {
    return a.some(function (v) { return b.indexOf(v) > -1; });
  }

  /* ---------- Sorting ---------- */
  function sortItems(list) {
    var s = state.sort;
    var sorted = list.slice();
    if (s === 'price-asc') sorted.sort(function (a, b) { return a.price - b.price; });
    else if (s === 'price-desc') sorted.sort(function (a, b) { return b.price - a.price; });
    else if (s === 'title-asc') sorted.sort(function (a, b) { return a.title.localeCompare(b.title); });
    else if (s === 'title-desc') sorted.sort(function (a, b) { return b.title.localeCompare(a.title); });
    else sorted.sort(function (a, b) { return a.index - b.index; });
    return sorted;
  }

  /* ---------- Apply (filter + sort + render) ---------- */
  /* historyMode: 'push' (default, user action) | 'replace' | 'none' */
  function apply(historyMode) {
    var visible = 0;
    var sorted = sortItems(items);

    sorted.forEach(function (it) {
      grid.appendChild(it.el); /* reorder */
      if (matches(it)) {
        it.el.classList.remove('cf-hidden');
        visible++;
      } else {
        it.el.classList.add('cf-hidden');
      }
    });

    if (countEl) countEl.textContent = visible + ' Product' + (visible === 1 ? '' : 's');
    if (emptyEl) emptyEl.hidden = visible !== 0;
    renderChips();
    updateDropdownCounts();
    updateToggleCount();
    updateApplyButton(visible);
    updateDdApplyCounts(visible);
    writeStateToUrl(historyMode || 'push');
    updateHeading();
    updateTabs();
  }

  /* Smooth re-render: fade the grid out, apply changes, then stagger
     the items back in. The container height is locked during the swap
     so the page below never jumps. */
  var smoothTimer = null;
  var smoothInTimer = null;
  function applySmooth() {
    if (!gridWrap) { apply('push'); return; }
    clearTimeout(smoothTimer);
    clearTimeout(smoothInTimer);

    /* lock current height to prevent layout jump while fading */
    gridWrap.style.minHeight = gridWrap.offsetHeight + 'px';
    gridWrap.classList.remove('cf-grid--in');
    gridWrap.classList.add('cf-grid--out');

    smoothTimer = setTimeout(function () {
      apply('push');
      gridWrap.classList.remove('cf-grid--out');
      gridWrap.classList.add('cf-grid--in');
      /* release the height lock on the next frame */
      requestAnimationFrame(function () {
        gridWrap.style.minHeight = '';
      });
      smoothInTimer = setTimeout(function () {
        gridWrap.classList.remove('cf-grid--in');
      }, 700);
    }, 190);
  }

  /* "Show N products" buttons inside dropdown popups.
     On mobile the open popup's panel is portaled out to <body>, so a
     query scoped to `root` would miss it and leave its count stale.
     Search the whole document to cover both in-place and portaled panels. */
  function updateDdApplyCounts(visible) {
    document.querySelectorAll('[data-cf-dd-apply-count]').forEach(function (el) {
      el.textContent = visible + ' product' + (visible === 1 ? '' : 's');
    });
  }

  /* Mobile "Show N products" apply button */
  function updateApplyButton(visible) {
    if (!applyCountEl) return;
    var hasActive = activeFiltersCount() > 0 || !!state.search ||
      (state.priceMin != null && state.priceMin > priceBounds.min) ||
      (state.priceMax != null && state.priceMax < priceBounds.max);
    applyCountEl.textContent = hasActive
      ? visible + ' product' + (visible === 1 ? '' : 's')
      : 'all products';
  }

  /* ---------- Chips ---------- */
  function chipLabel(key, value) {
    if (LABELS[key] && LABELS[key][value]) return LABELS[key][value];
    var inputs = root.querySelectorAll('input[data-cf-filter="' + key + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        var span = inputs[i].parentElement.querySelector('span');
        if (span) return span.textContent;
      }
    }
    return value;
  }

  function renderChips() {
    if (!chipsEl) return;
    var html = '';
    FILTER_KEYS.forEach(function (key) {
      state.filters[key].forEach(function (v) {
        html += '<button type="button" class="cf-chip" data-key="' + key + '" data-value="' +
          v.replace(/"/g, '&quot;') + '">' + chipLabel(key, v) + '</button>';
      });
    });
    chipsEl.innerHTML = html;
    var hasAny = html !== '';
    if (clearAllBtn) clearAllBtn.hidden = !hasAny && !state.search;
  }

  if (chipsEl) {
    chipsEl.addEventListener('click', function (e) {
      var chip = e.target.closest('.cf-chip');
      if (!chip) return;
      setFilter(chip.dataset.key, chip.dataset.value, false);
    });
  }
  if (clearAllBtn) clearAllBtn.addEventListener('click', clearAll);
  if (clearAllMobileBtn) clearAllMobileBtn.addEventListener('click', clearAll);
  root.querySelectorAll('[data-cf-reset]').forEach(function (b) { b.addEventListener('click', clearAll); });

  function activeFiltersCount() {
    var n = 0;
    FILTER_KEYS.forEach(function (k) { n += state.filters[k].length; });
    return n;
  }

  function updateDropdownCounts() {
    root.querySelectorAll('[data-cf-dd-count]').forEach(function (el) {
      var key = el.dataset.cfDdCount;
      var n = state.filters[key] ? state.filters[key].length : 0;
      el.textContent = n ? '(' + n + ')' : '';
    });
  }

  function updateToggleCount() {
    var n = activeFiltersCount();
    var open = panelOpen && !mqMobile.matches;
    root.querySelectorAll('[data-cf-panel-toggle] [data-cf-toggle-label]').forEach(function (label) {
      label.textContent = (open ? 'Hide Filter' : 'Filter') + (n ? ' (' + n + ')' : '');
    });
  }

  /* ---------- Search ---------- */
  if (searchInput) {
    var debounce;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounce);
      var val = this.value.trim().toLowerCase();
      debounce = setTimeout(function () {
        state.search = val;
        applySmooth();
      }, 180);
    });
  }

  /* ---------- Sort ----------
     Two selects share data-cf-sort (panel + inline mobile). Keep them
     in sync and re-render on change from either one. */
  function syncSortSelects(value) {
    if (!sortSelects) return;
    for (var i = 0; i < sortSelects.length; i++) {
      if (sortSelects[i].value !== value) sortSelects[i].value = value;
    }
  }
  if (sortSelects) {
    for (var si = 0; si < sortSelects.length; si++) {
      sortSelects[si].addEventListener('change', function () {
        state.sort = this.value;
        syncSortSelects(this.value);
        applySmooth();
      });
    }
  }


  /* ---------- Panel toggle (desktop sidebar / mobile bottom sheet) ---------- */
  var panelOpen = false;
  var panelCloseTimer = null;
  var savedScrollY = 0;

  function lockScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  }

  function setPanelOpen(open) {
    if (!panel || open === panelOpen) return;
    panelOpen = open;
    clearTimeout(panelCloseTimer);

    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (mqMobile.matches) {
      if (open) {
        panel.hidden = false;
        if (overlay) overlay.hidden = false;
        lockScroll();
        /* force reflow so the slide-up transition runs */
        void panel.offsetHeight;
        panel.classList.add('is-open');
        if (overlay) overlay.classList.add('is-visible');
      } else {
        panel.classList.remove('is-open');
        panel.style.transform = '';
        if (overlay) overlay.classList.remove('is-visible');
        unlockScroll();
        panelCloseTimer = setTimeout(function () {
          panel.hidden = true;
          if (overlay) overlay.hidden = true;
        }, 420);
      }
    } else {
      panel.hidden = !open;
      panel.classList.remove('is-open');
      if (overlay) { overlay.hidden = true; overlay.classList.remove('is-visible'); }
    }
    updateToggleCount();
  }

  root.querySelectorAll('[data-cf-panel-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setPanelOpen(!panelOpen);
    });
  });

  root.querySelectorAll('[data-cf-panel-close]').forEach(function (b) {
    b.addEventListener('click', function () { setPanelOpen(false); });
  });
  if (overlay) overlay.addEventListener('click', function () {
    setPanelOpen(false);
    if (openDd) setDdOpen(openDd, false);
  });
  if (applyBtn) applyBtn.addEventListener('click', function () { setPanelOpen(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panelOpen) setPanelOpen(false);
  });

  /* Keep things consistent when crossing the breakpoint while open */
  function onBreakpointChange() {
    if (panelOpen) {
      panelOpen = false;
      panel.hidden = true;
      panel.classList.remove('is-open');
      panel.style.transform = '';
      if (overlay) { overlay.hidden = true; overlay.classList.remove('is-visible'); }
      unlockScroll();
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      updateToggleCount();
    }
  }
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', onBreakpointChange);
  else if (mqMobile.addListener) mqMobile.addListener(onBreakpointChange);

  /* Swipe-down on the grip/header to close (mobile bottom sheet) */
  (function initDragClose() {
    var gripEl = panel ? panel.querySelector('[data-cf-panel-grip]') : null;
    if (!gripEl || !window.PointerEvent) return;
    var startY = 0, dy = 0, dragging = false;

    gripEl.addEventListener('pointerdown', function (e) {
      if (!mqMobile.matches || !panelOpen) return;
      if (e.target.closest('[data-cf-panel-close]')) return;
      dragging = true;
      startY = e.clientY;
      dy = 0;
      panel.classList.add('is-dragging');
      try { gripEl.setPointerCapture(e.pointerId); } catch (err) {}
    });
    gripEl.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    });
    var endDrag = function () {
      if (!dragging) return;
      dragging = false;
      panel.classList.remove('is-dragging');
      if (dy > 90) {
        setPanelOpen(false);
      } else {
        panel.style.transform = '';
      }
    };
    gripEl.addEventListener('pointerup', endDrag);
    gripEl.addEventListener('pointercancel', endDrag);
  })();

  /* Default: closed everywhere (desktop & mobile) */
  panel.hidden = true;
  updateToggleCount();

  /* ---------- Collapsible groups ---------- */
  root.querySelectorAll('[data-cf-group-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      this.closest('.cf-group').classList.toggle('is-collapsed');
    });
  });

  /* ---------- Dropdowns (bottom-sheet popups) ---------- */
  var openDd = null;

  /* Desktop: pick which side the popup opens to, based on available space */
  function positionDdPanel(dd) {
    var pnl = dd.querySelector('.cf-dd__panel');
    if (!pnl || mqMobile.matches) return;
    pnl.classList.remove('cf-dd__panel--right');
    var btnRect = dd.getBoundingClientRect();
    var panelW = 232; /* matches CSS width */
    var pad = 16;
    /* not enough room on the right -> anchor to the right edge of the button */
    if (btnRect.left + panelW + pad > window.innerWidth) {
      pnl.classList.add('cf-dd__panel--right');
    }
  }

  /* On mobile the dropdown panel is a bottom sheet. Because the sticky
     toolbar is its own stacking context, a panel nested inside it would
     render BELOW the full-screen overlay. To avoid that (and to avoid
     tinting the toolbar by raising its z-index), we relocate the panel
     to <body> while open, then put it back where it belongs on close. */
  /* Cache the panel element ONCE while it still lives inside the toolbar.
     After the first portal to <body>, dd.querySelector('.cf-dd__panel')
     would return null, which previously left the panel orphaned in <body>
     and the dropdown looked empty on the next open. Caching the reference
     keeps it reliable across repeated open/close cycles. */
  function getDdPanel(dd) {
    if (!dd.__cfPanelRef) {
      dd.__cfPanelRef = dd.querySelector('.cf-dd__panel');
      if (dd.__cfPanelRef) dd.__cfPanelRef.__cfOwnerDd = dd;
    }
    return dd.__cfPanelRef;
  }
  function portalPanel(dd) {
    var pnl = getDdPanel(dd);
    if (!pnl || pnl.__cfPortaled) return;
    pnl.__cfPortalParent = pnl.parentNode;
    pnl.__cfPortalNext = pnl.nextSibling;
    pnl.__cfPortaled = true;
    document.body.appendChild(pnl);
  }
  function unportalPanel(dd) {
    var pnl = getDdPanel(dd);
    if (!pnl || !pnl.__cfPortaled) return;
    if (pnl.__cfPortalParent) {
      pnl.__cfPortalParent.insertBefore(pnl, pnl.__cfPortalNext || null);
    }
    pnl.__cfPortaled = false;
  }

  function setDdOpen(dd, open) {
    if (open) {
      if (openDd && openDd !== dd) setDdOpen(openDd, false);
      if (panelOpen && mqMobile.matches) setPanelOpen(false);
      openDd = dd;
      positionDdPanel(dd);
      dd.classList.add('is-open');
      /* overlay + scroll lock only for the mobile bottom sheet */
      if (mqMobile.matches) {
        /* portal the panel out to <body> so it sits above the grey
           overlay instead of behind it. getDdPanel caches the element
           so this stays reliable across repeated open/close cycles. */
        var pnl = getDdPanel(dd);
        portalPanel(dd);
        /* the panel toggles its open state via the .cf-dd.is-open
           ancestor selector; once portaled it loses that ancestor, so
           drive its visibility with a dedicated class instead */
        if (pnl) {
          void pnl.offsetHeight;
          pnl.classList.add('cf-dd__panel--open');
        }
        if (overlay) {
          overlay.hidden = false;
          void overlay.offsetHeight;
          overlay.classList.add('is-visible');
        }
        lockScroll();
      }
    } else {
      if (openDd === dd) openDd = null;
      dd.classList.remove('is-open');
      if (dd.__cfPanelRef) dd.__cfPanelRef.classList.remove('cf-dd__panel--open');
      /* move the panel back into the toolbar after the close animation */
      if (dd.__cfPanelRef && dd.__cfPanelRef.__cfPortaled) {
        (function (d) {
          setTimeout(function () {
            if (!d.classList.contains('is-open')) unportalPanel(d);
          }, 400);
        })(dd);
      }
      if (!openDd && !panelOpen && mqMobile.matches) {
        if (overlay) {
          overlay.classList.remove('is-visible');
          setTimeout(function () { if (!openDd && !panelOpen) overlay.hidden = true; }, 320);
        }
        unlockScroll();
      }
    }
  }

  root.querySelectorAll('[data-cf-dd-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var dd = this.closest('.cf-dd');
      setDdOpen(dd, !dd.classList.contains('is-open'));
    });
  });

  /* Resolve the owning .cf-dd for a control inside a popup. Once the
     panel is portaled to <body> on mobile, .closest('.cf-dd') no longer
     works, so fall back to the panel's back-reference. */
  function ddFromControl(el) {
    var dd = el.closest('.cf-dd');
    if (dd) return dd;
    var pnl = el.closest('.cf-dd__panel');
    return pnl && pnl.__cfOwnerDd ? pnl.__cfOwnerDd : null;
  }

  /* close button & apply button inside each popup */
  root.querySelectorAll('[data-cf-dd-close], [data-cf-dd-apply]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dd = ddFromControl(this);
      if (dd) setDdOpen(dd, false);
    });
  });

  /* per-popup reset: clears only that filter group */
  root.querySelectorAll('[data-cf-dd-reset]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.dataset.cfDdReset;
      if (!key || !state.filters[key]) return;
      state.filters[key] = [];
      root.querySelectorAll('input[data-cf-filter="' + key + '"]').forEach(function (i) { i.checked = false; });
      applySmooth();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDd) setDdOpen(openDd, false);
  });

  /* desktop: close the dropdown when clicking outside */
  document.addEventListener('click', function (e) {
    if (!openDd || mqMobile.matches) return;
    if (!e.target.closest('.cf-dd')) setDdOpen(openDd, false);
  });

  /* ---------- Price slider ---------- */
  var priceMinInput, priceMaxInput, priceFill, priceMinLabel, priceMaxLabel;

  function computePriceBounds() {
    var min = Infinity, max = 0;
    items.forEach(function (it) {
      if (it.price < min) min = it.price;
      if (it.price > max) max = it.price;
    });
    if (!isFinite(min)) { min = 0; }
    priceBounds.min = Math.floor(min);
    priceBounds.max = Math.ceil(max);
    state.priceMin = priceBounds.min;
    state.priceMax = priceBounds.max;

    /* Hide price group if all products share the same price */
    var priceBox = root.querySelector('[data-cf-price]');
    if (priceBox && priceBounds.min === priceBounds.max) {
      var wrap = priceBox.closest('.cf-group');
      if (wrap) wrap.style.display = 'none';
    }
  }

  function initPriceSlider() {
    var box = root.querySelector('[data-cf-price]');
    if (!box) return;
    priceMinInput = box.querySelector('[data-cf-price-min]');
    priceMaxInput = box.querySelector('[data-cf-price-max]');
    priceFill = box.querySelector('.cf-price__track-fill');
    priceMinLabel = box.querySelector('[data-cf-price-min-label]');
    priceMaxLabel = box.querySelector('[data-cf-price-max-label]');

    [priceMinInput, priceMaxInput].forEach(function (inp) {
      inp.min = priceBounds.min;
      inp.max = priceBounds.max;
    });
    resetPriceSlider();

    /* Labels update instantly while dragging; the grid re-renders
       (with the smooth fade) only after the user stops moving. */
    var priceDebounce;
    var onInput = function () {
      var lo = parseFloat(priceMinInput.value);
      var hi = parseFloat(priceMaxInput.value);
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      state.priceMin = lo;
      state.priceMax = hi;
      updatePriceUI(lo, hi);
      clearTimeout(priceDebounce);
      priceDebounce = setTimeout(applySmooth, 250);
    };
    priceMinInput.addEventListener('input', onInput);
    priceMaxInput.addEventListener('input', onInput);
  }

  function resetPriceSlider() {
    if (!priceMinInput) return;
    priceMinInput.value = priceBounds.min;
    priceMaxInput.value = priceBounds.max;
    updatePriceUI(priceBounds.min, priceBounds.max);
  }

  function updatePriceUI(lo, hi) {
    if (priceMinLabel) priceMinLabel.textContent = '$' + lo;
    if (priceMaxLabel) priceMaxLabel.textContent = '$' + hi;
    if (priceFill) {
      var range = priceBounds.max - priceBounds.min || 1;
      var left = ((lo - priceBounds.min) / range) * 100;
      var right = ((hi - priceBounds.min) / range) * 100;
      priceFill.style.left = left + '%';
      priceFill.style.width = (right - left) + '%';
    }
  }

  /* ---------- Desktop: pin the filter button under the sticky header ----------
     When the user scrolls and the sticky site header reaches the toolbar,
     the standalone "Filter" button detaches and sticks right below the
     header (like a docked control), then releases when scrolling back up. */
  (function initDesktopFilterPin() {
    var mqDesktop = window.matchMedia('(min-width: 990px)');
    var filterBtn = root.querySelector('.cf-toolbar > .cf-filter-toggle');
    if (!filterBtn) return;

    var headerEl = document.querySelector('[data-sticky-header]') ||
      document.querySelector('#shopify-section-header');

    /* Placeholder keeps the button's slot in the toolbar while it is fixed */
    var placeholder = document.createElement('span');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';

    var pinned = false;
    var anchorTop = 0;   // page Y where the button originally sits
    var anchorLeft = 0;  // viewport X to keep the button aligned
    var btnWidth = 0;
    var btnHeight = 0;

    function headerHeight() {
      if (!headerEl) return 72;
      var h = headerEl.getBoundingClientRect().height;
      return h > 0 ? h : 72;
    }

    function measure() {
      /* Measure only while unpinned to get the true anchor position */
      if (pinned) return;
      var rect = filterBtn.getBoundingClientRect();
      anchorTop = rect.top + window.pageYOffset;
      anchorLeft = rect.left;
      btnWidth = rect.width;
      btnHeight = rect.height;
    }

    function pin() {
      if (pinned) return;
      pinned = true;
      placeholder.style.display = 'inline-flex';
      placeholder.style.width = btnWidth + 'px';
      placeholder.style.height = btnHeight + 'px';
      filterBtn.parentNode.insertBefore(placeholder, filterBtn);
      filterBtn.style.position = 'fixed';
      filterBtn.style.top = (headerHeight() + 10) + 'px';
      filterBtn.style.left = anchorLeft + 'px';
      filterBtn.style.zIndex = '40';
      filterBtn.classList.add('cf-filter-toggle--pinned');
    }

    function unpin() {
      if (!pinned) return;
      pinned = false;
      filterBtn.style.position = '';
      filterBtn.style.top = '';
      filterBtn.style.left = '';
      filterBtn.style.zIndex = '';
      filterBtn.classList.remove('cf-filter-toggle--pinned');
      if (placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
      placeholder.style.display = 'none';
    }

    function onScroll() {
      if (!mqDesktop.matches) { unpin(); return; }
      var threshold = anchorTop - headerHeight() - 10;
      if (window.pageYOffset > threshold) {
        pin();
        /* keep horizontal alignment in case of resize/scroll-x */
        filterBtn.style.left = anchorLeft + 'px';
      } else {
        unpin();
      }
    }

    function onResize() {
      unpin();
      measure();
      onScroll();
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    mqDesktop.addEventListener('change', onResize);
  })();

  /* ---------- Mobile: collapse the filter button to icon-only when the
     sticky toolbar docks under the header ----------
     The toolbar is position:sticky (top:59px). When the user scrolls and
     the bar reaches that docked position, we add a "stuck" class so the
     CSS can hide the "Filter" label and leave just the icon. */
  (function initMobileToolbarStuck() {
    /* Matches the breakpoint where the toolbar becomes position:sticky
       in collection-filters.css (max-width: 749px). */
    var mqMobile2 = window.matchMedia('(max-width: 749px)');
    var toolbar = root.querySelector('.cf-toolbar');

    if (!toolbar) return;

    /* Read the sticky offset (top) from the computed style so it stays
       in sync with the CSS value (59px) even if it changes later. */
    function stickyTop() {
      var t = parseFloat(window.getComputedStyle(toolbar).top);
      return isNaN(t) ? 59 : t;
    }

    var stuck = false;
    function setStuck(on) {
      if (on === stuck) return;
      stuck = on;
      toolbar.classList.toggle('cf-toolbar--stuck', on);
    }

    function onScroll() {
      if (!mqMobile2.matches) { setStuck(false); return; }
      /* Once the toolbar's top reaches (or passes) the sticky offset, it
         is docked. A 1px tolerance avoids flicker at the exact boundary. */
      var top = toolbar.getBoundingClientRect().top;
      setStuck(top <= stickyTop() + 1);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (mqMobile2.addEventListener) mqMobile2.addEventListener('change', onScroll);
    else if (mqMobile2.addListener) mqMobile2.addListener(onScroll);
    onScroll();
  })();

  /* ---------- Init ---------- */
  loadAllPages();
})();


